import { ButtonBase, Menu, MenuItem } from '@mui/material'
import { MoreVert } from '@mui/icons-material'
import * as React from 'react';
import ListLayerModuleItemContainer from '../_containers/ListLayerModuleItemContainer';
import { Trans } from 'react-i18next';
import PromptContainer from '@af-common/Common/_containers/PromptContainer';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export type Props = {
	id: string,
	layerCount: number,
	layerIndex: number,
	containerOffset: number,
	name?: string,
	selected?: boolean,
	visible?: boolean,
	selectLayer?: Function,
	moveLayer?: Function,
	layerVisibility?: Function,
	renameLayer?: Function,
	removeLayer?: (id:string) => void
	selectedLayerName?: string
};

type State = {
	isDragging: boolean
	height: number
	dragOrigin: number
	dragOffset: number
	renameOpened: boolean
	elem: HTMLElement | null
	menuOpen: boolean
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ListLayer extends React.Component<Props, State> {
	private ref:HTMLDivElement;
	private mouseMove: EventListener;
	private mouseUp: EventListener;

	state = {
		isDragging: false,
		height: 0,
		dragOrigin: 0,
		dragOffset: 0,
		renameOpened: false,
		elem: null,
		menuOpen: false
	} as State

	constructor(props:Props, state:State){
		super(props, state);
		this.mouseMove = this.onMouseMove.bind(this);
		this.mouseUp = this.onMouseUp.bind(this);
	}

	private onLayerRename		= (name:string)		=> this.props.renameLayer(this.props.id, name);
	private onRenameClose		= ()				=> this.setState({renameOpened: false});
	private onRenameOpen		= ()				=> this.setState({renameOpened: true});
	private onLayerRemove		= ()				=> this.props.removeLayer(this.props.id);

	componentDidMount(){
	}

	private getScrollOffset() {
		return 64;
	}

	private onMouseDown(e:React.MouseEvent) {
		console.log(e.target, e.currentTarget);
		//Stop here if we click on the options
		if(e.target instanceof Element && 
			(e.target.classList.contains('btn-layer-item-options') || e.target.closest('.btn-layer-item-options'))
			|| this.state.menuOpen
		) {
			console.log('test');
			return;
		} 

		this.props.selectLayer();
		this.align(e.clientY);
		this.setState({isDragging: true});
		document.addEventListener("mousemove", this.mouseMove);
		document.addEventListener("mouseup", this.mouseUp);
	}

	private onMouseMove(e:React.MouseEvent){
		this.setState({
			dragOffset: e.clientY - this.state.dragOrigin - this.getScrollOffset(),
		});

		let newIndex =  this.props.layerCount -  1 - Math.max(0, Math.min(Math.floor((this.state.dragOffset - this.props.containerOffset) / this.state.height), this.props.layerCount - 1));

		newIndex !== this.props.layerIndex && this.props.moveLayer(newIndex - this.props.layerIndex);
	}

	private onMouseUp(e:React.MouseEvent) {
		this.setState({isDragging: false});
		document.removeEventListener("mousemove", this.mouseMove);
		document.removeEventListener("mouseup", this.mouseUp);
	}

	private align(y?:number){
		const rect = this.ref.getBoundingClientRect();
		const style = getComputedStyle(this.ref);

		y = y || rect.top;

		//TODO: The height here isn't perfect for some reason...might need to be calculated at some other moment
		this.setState({
			height: rect.height + parseFloat(style.getPropertyValue('margin-top')) + parseFloat(style.getPropertyValue('margin-bottom')),
			dragOrigin: y - rect.top,
			dragOffset: y - (y - rect.top) - this.getScrollOffset(),
		});
	}

	private onVisibility(e:React.MouseEvent) {
		e.stopPropagation();
		this.props.layerVisibility(!this.props.visible);
	}

	private getStyle = (offset:number) => ({
		zIndex: this.state.isDragging ? 2 : undefined,
		top: this.state.isDragging ? offset + 'px' : undefined,
	} as React.CSSProperties);

	private setElem = (element:HTMLElement) => {
		if (this.state.elem) return;
		this.setState({elem: element});
	}

	render() {
		const floating = this.state.isDragging;

		let placeholderStyle = {
			height: this.ref ? this.ref.clientHeight : 0
		};

		return <>
			{floating && <div className={"mdc-list-item mdc-list-item-placeholder"} style={placeholderStyle}></div>}
			<div
				style={this.getStyle(this.state.isDragging ? this.state.dragOffset : 0)}
				className={"mdc-list-item mdc-ripple-upgraded" + (floating ? " floating" : "") + (this.props.selected ? " mdc-list-item--selected" : "")}
				onMouseDown={(e:React.MouseEvent) => this.onMouseDown(e)}
				ref={ref => this.ref = ref}
			>
					<div className="layer-title">
						<ButtonBase className="layer-icon">
							{this.props.visible ? 
								<Visibility onMouseDown={(e:React.MouseEvent) => this.onVisibility(e)} /> :
								<VisibilityOff onMouseDown={(e:React.MouseEvent) => this.onVisibility(e)} />
							}
						</ButtonBase>
						<div style={{flexGrow: 1, textAlign: 'left'}}>{this.props.name}</div>
						<div className="btn-layer-item-options" onMouseDown={(e:React.MouseEvent) => {this.setState({menuOpen: !this.state.menuOpen})}} ref={this.setElem}><MoreVert /></div>
						<Menu
							id="simple-menu"
							anchorEl={this.state.elem}
							keepMounted
							onClose={() => this.setState({menuOpen: false})}
							open={this.state.menuOpen}
						>
							<MenuItem onMouseDown={(e:React.MouseEvent) => {
								this.props.id && this.onRenameOpen();
								this.setState({menuOpen: false});
							}} >
								<T>Rename</T>
							</MenuItem>
							<MenuItem onMouseDown={(e:React.MouseEvent) => {
								this.props.id && this.onLayerRemove();
								this.setState({menuOpen: false});
							}}>
								<T>Delete</T>
							</MenuItem>
						</Menu>
					</div>
					<div className="layer-module-list">
						{ 
							this.props.moduleIds.count() > 0 ?  this.props.moduleIds.entrySeq().reverse().map(([id, module], index) => {
									return <ListLayerModuleItemContainer key={id} moduleId={id}/>
								}) 
								: <em className="layer-module-item"><T>Empty</T></em>
						}
					</div>
			</div>
			{/* Rename Dialog */}
			<PromptContainer
				opened={this.state.renameOpened}
				title={<T>Rename Layer</T>}
				input={this.onLayerRename}
				name={this.props.selectedLayerName}
				onClose={this.onRenameClose}
				dismissible
			/>
		</>
	}
}